module.exports = __webpack_public_path__ + "static/media/3-circle-unavailable.af49f46b.svg";